// extracted by mini-css-extract-plugin
module.exports = {"RichText":"RichTextInput_RichText__2wJb-"};